export let PlayerStatus;
(function (PlayerStatus) {
  PlayerStatus["INITIAL"] = "INITIAL";
  PlayerStatus["LOADING"] = "LOADING";
  PlayerStatus["READY"] = "READY";
  PlayerStatus["PLAYING"] = "PLAYING";
  PlayerStatus["PAUSED"] = "PAUSED";
  PlayerStatus["ENDED"] = "ENDED";
  PlayerStatus["CONVERSION_ASSET_OVERLAY"] = "CONVERSION_ASSET_OVERLAY";
  PlayerStatus["ERROR"] = "ERROR";
})(PlayerStatus || (PlayerStatus = {}));
export const PlayerTypes = {
  DEFAULT: 'hsvideo-mux',
  // default implicit type (just for usage tracking)
  VIDEOJS_RAW_URL: 'videojs-raw-url',
  // for non-embeddable video or when lacking a Mux `primaryPlaybackId` (just for usage tracking)
  HTML5: 'html5',
  // used for non-embeddable aka "raw" videos, or when `?playerType=html5` query param used
  IN_APP_PREVIEW: 'inAppPreview',
  // general in-app preview player use case, default when VideoPlayer component is used
  EDITOR_PREVIEW: 'editorPreview',
  // players in content editor previews, start the same as rich text but can be upgraded into a Mux player & play on click
  RICH_TEXT_PREVIEW: 'richTextPreview',
  // players in tinymce content being actively edited show a non-interactive poster image
  ACADEMY_IN_APP: 'academy',
  // for showing in-app help videos from portal
  ACADEMY_EMBEDDED: 'academyEmbedded' // a separate academy use case where we don't want the picture-in-picture button https://hubspot.slack.com/archives/C06P3CWEXHB/p1747327269881999?thread_ts=1746031922.230629&cid=C06P3CWEXHB
};

// These are the enabled hotkeys from the parent frame when the enableParentHotKeys prop is true
export const EnabledKeyboardKeys = {
  SPACE: 'Space',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  M: 'KeyM',
  F: 'KeyF'
};